// *******************************************************************************
// 1.0 - Mobile menu toggle
// *******************************************************************************

attachEvent('.mobile-hamburger', 'click', (ev) => {
  ev.preventDefault();

  // Open menu
  document.body.classList.toggle('is-open-menu');
  const hamburger = ev.target.closest('.mobile-hamburger');

  const isOpen = hamburger.classList.contains('is-open');

  hamburger.classList.toggle('is-open', !isOpen);
  hamburger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
});

// *******************************************************************************
// 2.0 - Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffert > 20);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

const headerMainHeight = () => {
  const headerMain = document.querySelector('.header-main');
  if (headerMain) {
    setTimeout(() => {
      const headerMainHeight = `${headerMain.offsetHeight}px`;
      document.body.style.setProperty('--header-height', headerMainHeight);
    }, 10);
  }
};

headerMainHeight();

const debounceHeaderHeight = debounce(() => {
  headerMainHeight();
}, 100);

window.addEventListener('resize', () => {
  debounceHeaderHeight();
});
